import * as actionTypes from '../actionTypes/promoterTypes';
import axios from '../../axios-instance';
import { toast } from 'react-toastify';
import { getHeaders } from '../../helpers/getHeaders';

const getPromoterInfoStart = () => ({ type: actionTypes.GET_PROMOTER_INFO_START });
const getPromoterInfoSuccess = (data) => ({
  type: actionTypes.GET_PROMOTER_INFO_SUCCESS,
  payload: data,
});
const getPromoterInfoFail = (error) => ({
  type: actionTypes.GET_PROMOTER_INFO_FAIL,
  error,
});

export const getPromoterInfo = (userToken) => (dispatch) => {
  dispatch(getPromoterInfoStart());

  return axios
    .get(`/Users/self`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getPromoterInfoSuccess(response.data.result));

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Promoter info not received');
      dispatch(getPromoterInfoFail(err));
    });
};

const getIframesStart = () => ({ type: actionTypes.GET_IFRAMES_START });
const getIframesSuccess = (iframes) => ({
  type: actionTypes.GET_IFRAMES_SUCCESS,
  payload: iframes,
});
const getIframesFail = (error) => ({
  type: actionTypes.GET_IFRAMES_FAIL,
  error,
});

export const getIframes = (userToken) => (dispatch) => {
  dispatch(getIframesStart());

  return axios
    .get(`/iFrame/List`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getIframesSuccess(response.data.result));

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Iframes not received');
      dispatch(getIframesFail(err));
    });
};

const getIframeStart = () => ({ type: actionTypes.GET_IFRAME_START });
const getIframeSuccess = (iframe) => ({
  type: actionTypes.GET_IFRAME_SUCCESS,
  payload: iframe,
});
const getIframeFail = (error) => ({ type: actionTypes.GET_IFRAME_FAIL, error });

export const getIframeById = (id, userToken) => (dispatch) => {
  dispatch(getIframeStart());

  return axios
    .get(`/iFrame/ById/${id}`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getIframeSuccess(response.data.result));

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Iframe not received');
      dispatch(getIframeFail(err));
    });
};

const getAvailableEventsStart = () => ({
  type: actionTypes.GET_AVAILABLE_EVENTS_START,
});
const getAvailableEventsSuccess = (events) => ({
  type: actionTypes.GET_AVAILABLE_EVENTS_SUCCESS,
  payload: events,
});
const getAvailableEventsFail = (error) => ({
  type: actionTypes.GET_AVAILABLE_EVENTS_FAIL,
  error,
});

export const getAvailableEvents = (userToken) => (dispatch) => {
  dispatch(getAvailableEventsStart());

  return axios
    .get(`/iFrame/Events`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getAvailableEventsSuccess(response.data.result));

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Available events not received');
      dispatch(getAvailableEventsFail(err));
    });
};

const updateIframeStart = () => ({ type: actionTypes.UPDATE_IFRAME_START });
const updateIframeSuccess = (iframe) => ({
  type: actionTypes.UPDATE_IFRAME_SUCCESS,
  payload: iframe,
});
const updateIframeFail = (error) => ({
  type: actionTypes.UPDATE_IFRAME_FAIL,
  error,
});

export const updateIframe = (data, userToken) => (dispatch) => {
  dispatch(updateIframeStart());

  return axios
    .put(`/iFrame`, data, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(updateIframeSuccess(data));

        toast.success('Iframe successfully saved');

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Iframe not saved');
      dispatch(updateIframeFail(err));
    });
};

const deleteIframeStart = () => ({ type: actionTypes.DELETE_IFRAME_START });
const deleteIframeSuccess = (iframeId) => ({
  type: actionTypes.DELETE_IFRAME_SUCCESS,
  payload: iframeId,
});
const deleteIframeFail = (error) => ({
  type: actionTypes.DELETE_IFRAME_FAIL,
  error,
});

export const deleteIframe = (id, userToken) => (dispatch) => {
  dispatch(deleteIframeStart());

  return axios
    .delete(`/iFrame/${id}`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(deleteIframeSuccess());

        toast.success('Iframe successfully deleted');

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Iframe not deleted');
      dispatch(deleteIframeFail(err));
    });
};

const getStyleThemeStart = () => ({ type: actionTypes.GET_THEME_START });
const getStyleThemeSuccess = (iframe) => ({
  type: actionTypes.GET_THEME_SUCCESS,
  payload: iframe,
});
const getThemeFail = (error) => ({ type: actionTypes.GET_THEME_FAIL, error });

export const getPromoterStyleTheme = (userToken) => (dispatch) => {
  dispatch(getStyleThemeStart());

  return axios
    .get(`/PageUiTheme`, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(getStyleThemeSuccess(response.data.result));

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Style theme not received');
      dispatch(getThemeFail(err));
    });
};

const updateStyleThemeStart = () => ({ type: actionTypes.UPDATE_THEME_START });
const updateStyleThemeSuccess = (iframe) => ({
  type: actionTypes.UPDATE_THEME_SUCCESS,
  payload: iframe,
});
const updateThemeFail = (error) => ({
  type: actionTypes.UPDATE_THEME_FAIL,
  error,
});

export const updatePromoterStyleTheme = (userToken, theme) => (dispatch) => {
  dispatch(updateStyleThemeStart());

  return axios
    .put(`/PageUiTheme`, theme, { headers: getHeaders(userToken) })
    .then((response) => {
      if (response.data.isSuccess) {
        dispatch(updateStyleThemeSuccess(response.data.result));

        toast.success('Your theme was successfully edited');

        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .catch((err) => {
      toast.error('Your theme was not edited');
      dispatch(updateThemeFail(err));
    });
};
